import getSpacingInNormalDirection from '../../../utilities/getSpacingInNormalDirection.js';
export function fidelityDisplayOfCamera(viewport, volume3D = false) {
    const camera = viewport.getCamera?.();
    const parallelScale = camera?.parallelScale;
    const height = viewport.canvas?.height ||
        viewport.canvas?.clientHeight ||
        viewport.sHeight;
    if (!(parallelScale > 0) || !(height > 0)) {
        return undefined;
    }
    return {
        pixelSpacing: (2 * parallelScale) / height,
        viewPlaneNormal: camera.viewPlaneNormal,
        volume3D,
    };
}
export function pixelSpacingOfCanvasToWorld(canvasToWorld) {
    const a = canvasToWorld([0, 0]);
    const b = canvasToWorld([1, 0]);
    const cssPixel = Math.hypot(b[0] - a[0], b[1] - a[1], b[2] - a[2]);
    const ratio = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    return cssPixel > 0 && Number.isFinite(cssPixel)
        ? cssPixel / ratio
        : undefined;
}
export function displaySpacingForGrid(display, grid, sourceGrid = grid) {
    const { pixelSpacing: pixel, viewPlaneNormal: normal, volume3D } = display;
    const slice = !volume3D && normal ? getSpacingInNormalDirection(sourceGrid, normal) : 0;
    const spacing = [pixel, pixel, pixel];
    for (let axis = 0; axis < 3; axis++) {
        if (slice > 0) {
            const offset = axis * 3;
            const c = Math.min(1, Math.abs(grid.direction[offset] * normal[0] +
                grid.direction[offset + 1] * normal[1] +
                grid.direction[offset + 2] * normal[2]));
            const inPlane = c < 1 - 1e-9 ? pixel / Math.sqrt(1 - c * c) : Number.POSITIVE_INFINITY;
            const alongNormal = c > 1e-9 ? slice / c : Number.POSITIVE_INFINITY;
            const blended = Math.min(inPlane, alongNormal);
            spacing[axis] = Number.isFinite(blended) ? blended : pixel;
        }
        spacing[axis] = Math.max(spacing[axis], sourceGrid.spacing[axis] || 0);
    }
    return spacing;
}
export function displaySpacingOfDisplay(display) {
    return display
        ? [display.pixelSpacing, display.pixelSpacing, display.pixelSpacing]
        : undefined;
}
export function displaySpacingOfViewport(viewport, options = {}) {
    const display = fidelityDisplayOfCamera(viewport, options.volume3D);
    if (!display || !options.grid) {
        return displaySpacingOfDisplay(display);
    }
    return displaySpacingForGrid(display, options.grid, options.sourceGrid);
}
